<div class="logged-out-root">
    <form id="form-login">
        <fieldset>
            <legend>Log in</legend>
            <div class="input-group">
                <span>Username:</span>
                <input class="username" type="text" autocomplete="username" placeholder="Enter username" required>
                <span>Password:</span>
                <input class="password" type="password" autocomplete="current-password" placeholder="Enter password" required>
            </div>
            <button class="submit" type="submit">Log in</button>
        </fieldset>
    </form>
    <form id="form-register">
        <fieldset>
            <legend>Register</legend>
            <div class="input-group">
                <span>Username:</span>
                <input class="username" type="text" autocomplete="username" placeholder="Enter username" required>
                <span>E-Mail:</span>
                <input class="email" type="text" autocomplete="email" placeholder="Enter e-mail address" required>
                <span>Password:</span>
                <input class="password" type="password" autocomplete="new-password" placeholder="Enter password" required>
                <span>Confirm:</span>
                <input class="password-confirm" type="password" autocomplete="new-password" placeholder="Confirm password" required>
            </div>
            <button class="submit" type="submit">Register</button>
        </fieldset>
    </form>
    <span class="msg"></span>
</div>